/* eslint-disable react/forbid-prop-types */
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import InputCheckBoxContainer from 'commons-forms/components/InputCheckbox/InputCheckboxContainer.jsx';
import InputDropDown from 'commons-forms/components/InputDropDown/InputDropDown.jsx';
import InputEmail from 'commons-forms/components/InputEmail/InputEmail.jsx';
import InputPhoneNumber from 'commons-forms/components/InputPhoneNumber/InputPhoneNumber.jsx';
import InputRadioContainer from 'commons-forms/components/InputRadio/InputRadioContainer.jsx';
import InputText from 'commons-forms/components/InputText/InputText.jsx';
import InputZipCode from 'commons-forms/components/InputZipCode/InputZipCode.jsx';
import TextArea from 'commons-forms/components/TextArea/TextArea.jsx';

class FormBuilder extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isValid: !props.inputParams.isRequired,
            value: props.inputParams.value,
        };

        this.onChange = this.onChange.bind(this);
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            value: newProps.inputParams.value,
        });
    }

    onChange(newValue, name) {
        const { inputParams, onChange } = this.props;
        const isValid = !inputParams.isRequired || !!newValue;

        this.setState({
            isValid,
            value: newValue,
        });

        onChange(newValue, name, isValid);
    }

    render() {
        const { inputParams } = this.props;
        const { isValid, value } = this.state;

        const classNames = ['styled-placeholder', `${inputParams.classNames}`];

        switch (inputParams.inputType) {
            case 'phone':
                return (
                    <InputPhoneNumber
                        label={inputParams.label}
                        name={inputParams.name}
                        classNames={classNames}
                        isRequired={inputParams.isRequired}
                        valueChange={(changedValue) =>
                            this.props.onChange(changedValue.value, inputParams.name, changedValue.validation)
                        }
                        value={value}
                        isValid={isValid}
                    />
                );
            case 'postalCode':
                return (
                    <InputZipCode
                        classNames={classNames}
                        label={inputParams.label}
                        value={value}
                        isValid={isValid}
                        isRequired={inputParams.isRequired}
                        onChange={(changedValue) =>
                            this.props.onChange(changedValue.value, inputParams.name, changedValue.validation)
                        }
                    />
                );
            case 'email':
                return (
                    <InputEmail
                        label={inputParams.label}
                        classNames={classNames}
                        isRequired={inputParams.isRequired}
                        valueChange={this.onChange}
                        value={value}
                        isValid={isValid}
                    />
                );
            case 'dropdown':
                return (
                    <InputDropDown
                        options={inputParams.options}
                        placeholder={inputParams.label}
                        name={inputParams.name}
                        classNames={['input-dropdown'].concat(inputParams.classNames)}
                        isRequired={inputParams.isRequired}
                        valueChange={(changedValue) => this.onChange(changedValue.value, inputParams.name, true)}
                        value={value}
                        isValid={isValid}
                    />
                );
            case 'radio':
                return (
                    <InputRadioContainer
                        options={inputParams.options}
                        value={value}
                        label={inputParams.label}
                        name={inputParams.name}
                        onChange={(changedValue) => this.props.onChange(changedValue, inputParams.name, true)}
                    />
                );
            case 'textarea':
                return (
                    <TextArea
                        {...inputParams}
                        value={value}
                        valueChange={(inputValue, name) => this.onChange(inputValue, name, true)}
                        classNames={classNames}
                    />
                );
            case 'checkbox':
                return (
                    <InputCheckBoxContainer
                        {...inputParams}
                        onChange={(changedValue, name) => this.props.onChange(changedValue, name, true)}
                    />
                );
            case 'subhead':
                return (
                    <div className="clearfix">
                        <h4 className="sr-text is-bold">{inputParams.label}</h4>
                    </div>
                );
            default:
                return (
                    <InputText
                        label={inputParams.label}
                        name={inputParams.name}
                        type={inputParams.inputType}
                        classNames={classNames}
                        isRequired={inputParams.isRequired}
                        valueChange={this.onChange}
                        value={value}
                        isValid={isValid}
                    />
                );
        }
    }
}

FormBuilder.defaultProps = {
    onChange: noop,
};

FormBuilder.propTypes = {
    inputParams: PropTypes.shape({
        name: PropTypes.string.isRequired,
        label: PropTypes.string,
        inputType: PropTypes.string.isRequired,
        classNames: PropTypes.string,
        isRequired: PropTypes.bool,
        options: PropTypes.any,
        value: PropTypes.any,
        placeholder: PropTypes.string,
    }).isRequired,
    onChange: PropTypes.func,
};

FormBuilder.displayName = 'FormBuilder';

export default FormBuilder;
